import React, {useEffect} from 'react';
import * as S from './StatusPopup.styles';
import classNames from 'classnames';
export const StatusPopup = ({data, onCloseIconClick}) => {
  const {header = {}, body = {}, footer = {}} = data || {};

  const timeInMS = header?.refreshTimeout || 3000;
  useEffect(() => {
    setTimeout(() => {
      window.location.reload();
    }, timeInMS);
  }, []);
  return (
    <S.Container>
      <S.Header>
        {header?.showCrossIcon && (
          <S.CloseIcon className={classNames('mr12 sprite icClose')} onClick={onCloseIconClick} />
        )}

        <span className={classNames('mr12', header?.icon?.iconClasses)} />
      </S.Header>
      <S.Body>
        <p className="primaryText">{body?.primaryText}</p>
        <p className="secondaryText">{body.secondaryText}</p>
      </S.Body>
      <S.Footer>
        <div className="text">{`${footer?.primaryText} - ${timeInMS / 1000} sec`}</div>
      </S.Footer>
    </S.Container>
  );
};
